import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=4d697639&functional=true&"
import script from "./VButton.vue?vue&type=script&lang=js&"
export * from "./VButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d697639')) {
      api.createRecord('4d697639', component.options)
    } else {
      api.rerender('4d697639', component.options)
    }
    module.hot.accept("./VButton.vue?vue&type=template&id=4d697639&functional=true&", function () {
      api.rerender('4d697639', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/volta/VButton.vue"
export default component.exports